import { css } from '@emotion/css';
import { N50 } from '@/colors/colorsV1';

const px = num => {
  switch (typeof num) {
    case 'number':
      return `${num}px`;
    case 'string':
    default:
      return num;
  }
};

export const stySeparator = ({ height, top, bottom, color, isShadow }) => css`
  ${{
    height,
    marginTop: top,
    marginBottom: bottom,
  }}
  background-color: ${color || N50};

  ${isShadow && `box-shadow: rgb(51 51 51 / 16%) 0px 2px 8px 0px;`}
`;
